// Storefront sales platforms. The backend scopes catalog, cart and checkout by
// `platform_slug`; a location that sells to businesses lists the B2B slug in
// its `location_platforms`.
export const PLATFORM_SLUG = Object.freeze({
  ECOMMERCE: 'ecommerce',
  ECOMMERCE_B2B: 'ecommerce-b2b',
});

// Payment-method slug of the B2B "credit" tender (pay against the customer's
// credit limit). Offered on ecommerce-b2b only.
export const CREDIT_PAYMENT_SLUG = 'credit';

// Mirrors the backend `customers.CustomerType` enum.
export const CUSTOMER_TYPE = Object.freeze({
  INDIVIDUAL: 'INDIVIDUAL',
  BUSINESS: 'BUSINESS',
});

// Countries whose business customers register a VAT number in addition to the
// other tax identifiers (GCC VAT states, UK, EU, and other VAT regimes).
export const VAT_COUNTRIES = Object.freeze(
  new Set([
    'AE',
    'SA',
    'BH',
    'OM',
    'EG',
    'GB',
    'IE',
    'FR',
    'DE',
    'IT',
    'ES',
    'NL',
    'BE',
    'PT',
    'AT',
    'SE',
    'DK',
    'FI',
    'PL',
    'GR',
    'ZA',
    'KE',
    'NG',
  ]),
);

const COUNTRY_ALIASES = { UAE: 'AE', KSA: 'SA', UK: 'GB' };

/** @param {string} [country] ISO-2 code (or a common alias such as UAE/KSA). */
export function requiresVatNumber(country) {
  const code = String(country || '')
    .trim()
    .toUpperCase();
  return VAT_COUNTRIES.has(COUNTRY_ALIASES[code] || code);
}

/** @param {string} [customerType] */
export function platformSlugFor(customerType) {
  return customerType === CUSTOMER_TYPE.BUSINESS
    ? PLATFORM_SLUG.ECOMMERCE_B2B
    : PLATFORM_SLUG.ECOMMERCE;
}

/** Order/cart `source` — mirrors the platform slug. */
export const orderSourceFor = platformSlugFor;
